import { render, staticRenderFns } from "./LiveEvent.vue?vue&type=template&id=70bb7588&scoped=true"
import script from "./LiveEvent.vue?vue&type=script&lang=js"
export * from "./LiveEvent.vue?vue&type=script&lang=js"
import style0 from "./LiveEvent.vue?vue&type=style&index=0&id=70bb7588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb7588",
  null
  
)

export default component.exports